import uuid from 'uuid/v4';

function make(alerts = [], code, type, message) {
	const results = alerts;
	const index = alerts.findIndex(it => it.code === code);
	const value = {
		code,
		type,
		message,
	};

	if (index !== -1) {
		results[index] = Object.assign(alerts[index], { ...value });
	} else {
		results.push({ id: uuid(), ...value });
	}

	return results;
}

function generate(alerts = [], cb = () => {}) {
	const results = [];

	alerts.forEach(it => results.push({ type: it.type, id: it.id, message: cb(it.message) }));

	return results;
}

export default {
	make,
	generate,
};
